import { useQuery } from '@tanstack/react-query';
import { DashboardApi } from '@Apis';
import { DashboardPeriod } from '@Types/dashboard';
import { useDashboardServicesStore } from '@Models/useDashboardServicesModel';

export const useDashboardWidget = <TData = any>(
  widget: string,
  period?: DashboardPeriod,
  options?: {
    enabled?: boolean;
    select?: (response: any) => TData;
  }
) => {
  const servicesModel = useDashboardServicesStore();

  return useQuery({
    queryKey: [
      'dashboardWidget',
      widget,
      servicesModel.enabledServices,
      period,
    ],
    queryFn: () =>
      DashboardApi.getDashboardWidget(
        widget,
        servicesModel.enabledServices,
        period
      ),
    enabled:
      (options?.enabled ?? true) && servicesModel.hasEnabledProvisionedServices,
    select: options?.select ?? ((response: any) => response.data),
  });
};
